import React from "react";
import "./style.css";
import instagramIconBW from '../../assets/images/png/instagram_bw.png'
import facebookIconBW from '../../assets/images/png/facebookbw.png'
import { Tooltip } from 'react-tooltip'
import airbnbbw from '../../assets/images/png/airbnbbw.png'
import tiktokbw from '../../assets/images/png/tiktok_bw.png'



export default function Header() {

    return (
        <div>
            <header className="header fixed-top">
                <div className="socialMedia1">
                    <div className="socialBar container d-flex align-items-end justify-content-end pt-1">
                        <a href='https://www.instagram.com/repsemdestino/'
                            data-tooltip-id="instagram-tooltip"
                            data-tooltip-content="Acesse nosso Instagram!"
                            data-tooltip-place="bottom-end"
                            data-tooltip-offset={10}>
                            <img
                                src={instagramIconBW}
                                width={25}
                                alt="Logotipo instagram"
                                className="socialMediaSpace"
                            />
                            <Tooltip id="instagram-tooltip" />
                        </a>
                        <a href='https://www.facebook.com/RepublicaSemDestino/'
                            data-tooltip-id="facebook-tooltip"
                            data-tooltip-content="Acesse nossa página no Facebook!"
                            data-tooltip-place="bottom-end"
                            data-tooltip-offset={10}>
                            <img
                                src={facebookIconBW}
                                width={25}
                                alt="Logotipo facebook"
                                className="socialMediaSpace" />
                            <Tooltip id="facebook-tooltip" />
                        </a>
                        <a href='https://www.tiktok.com/@repsemdestino'
                            data-tooltip-id="tiktok-tooltip"
                            data-tooltip-content="Acesse nosso TikTok!"
                            data-tooltip-place="bottom-end"
                            data-tooltip-offset={10}>
                            <img
                                src={tiktokbw}
                                width={25}
                                alt="Logotipo tiktok"
                                className="socialMediaSpace" />
                            <Tooltip id="tiktok-tooltip" />
                        </a>
                        <a href='https://www.airbnb.com.br/users/show/32669058'
                            data-tooltip-id="airbnb-tooltip"
                            data-tooltip-content="Hospede-se na Sem Destino pelo AirBnB!"
                            data-tooltip-place="bottom-end"
                            data-tooltip-offset={10}>
                            <img
                                src={airbnbbw}
                                width={25}
                                alt="Logotipo AirBnB"
                                className="socialMediaSpace" />
                            <Tooltip id="airbnb-tooltip" />
                        </a>
                    </div>
                </div>
            </header >
        </div>
    );
}
